import React, { useEffect, useState } from 'react'
import tickIcon from '../images/icons/MdCheck.svg';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { loginValidationSchema } from '../utils/yubSchema/authSchemeValidation';
import { yupResolver } from '@hookform/resolvers/yup';
import { userLoginApi } from '../utils/commonapi';
import CustomizedSnackbars from '../components/baseComponents/Snackbar';
import { useDispatch } from 'react-redux';
import { errorToLogin, setLoginRequest, setUserDetails } from '../reducers/auth';


const Login = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const redirect = params.get('redirect');
  const navigate = useNavigate();

  useEffect(() => {
    // Add padding to the body when component mounts
    document.body.classList.add('pb-0');

    // Clean up function to remove padding when component unmounts
    return () => {
      document.body.classList.remove('pb-0');
    };
  }, []); // Only run on mount and unmount

  const { register, handleSubmit, reset, formState } = useForm({
    resolver: yupResolver(
      loginValidationSchema
    ),
    mode: "onSubmit",
    reValidateMode: "onBlur"
  })
  const { errors } = formState;

  const handleApiError = (error) => {
    let errorMessage = 'An error occurred';
    if (error?.response) {
      errorMessage = error?.response?.data?.message;
    } else if (error?.request) {
      errorMessage = 'No response received from server';
    }
    setSnackbarMessage(errorMessage);
    setOpenSnackbar(true);
  };

  const handleSubmitLogin = async (data) => {
    try {
      dispatch(setLoginRequest());
      const response = await userLoginApi(data);
      if (response) {
        const { data: { data, success, token } } = response;
        const objData = {
          userToken: token,
          userInfo: data,
          success: success
        }
        dispatch(setUserDetails(objData));
        if (redirect) {
          window.open(redirect, "_self");
        } else {
          navigate('/')
        }
      }
      reset();
    } catch (error) {
      const errorData = {
        error: error
      }
      dispatch(errorToLogin(errorData));
      console.log("🚀 ~ reviewHandleSubmit ~ error:", error);
      handleApiError(error);
    }
  };

  const handleCloseSnackbar = (isOpen) => {
    setOpenSnackbar(isOpen);
    setSnackbarMessage('');
  }

  return (
    <>
      <section className='auth-section'>
        <div className="container-fluid p-0">
          <div className="row m-0">
            <div className="col-lg-6 p-0 d-none d-lg-block">
              <div className="content-section">
                <div className="content">
                <h1>Eop</h1>
                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Pariatur inventore eaque illum fugiat repudiandae repellendus atque, nulla, autem sunt hic quasi fuga ex iste est! Id rerum autem ad dolorum.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 p-0">
              <div className="form-section">
                <div className="login-title">
                  <h2>Eop</h2>
                  <p>Sign In Into Your Account</p>
                </div>
                <form action="" method="post" onSubmit={handleSubmit(handleSubmitLogin)}>
                  <div className="form-group mb-4">
                    <input type="email" name="email" {...register('email')} id="email" placeholder='Enter the email id' className='form-control email' />
                    <small className='text-danger err'>{errors?.email?.message}</small>
                  </div>
                  <div className="form-group mb-4">
                    <input type="password" name="password" {...register('password')} id="password" placeholder='Enter the password' className='form-control password' />
                    <small className='text-danger err'>{errors?.password?.message}</small>
                  </div>
                  <div className="forget-password__wrapper mb-4">
                    <div className="remember-me__wrapper">
                      <div className="form-check d-flex p-0 m-0">
                        <input className="form-check-input d-none" type="checkbox" value="" id="flexCheckDefault"/>
                        <label className="form-check-label mt-1" htmlFor="flexCheckDefault">
                          <div className="cus-checkbox">
                            <img src={tickIcon} alt="tickIcon" />
                          </div>
                          <span>Remember Me</span>
                        </label>
                      </div>
                    </div>
                    <Link to={'/'}>Forgot password?</Link>
                  </div>
                  <button type="submit" className='btn btn-org'>Submit</button>
                  <p className='mt-3'>Not registered yet? <Link to={'/register'}>Create an account</Link></p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {openSnackbar && <CustomizedSnackbars open={openSnackbar} message={snackbarMessage} severity="error" variant={'filled'} handleClose={handleCloseSnackbar} />}
    </>
  )
}

export default Login
